$ = jQuery;
$(document).ready(function () {
  $(".cart-qty").change(function () {
    Shopify.changeItem($(this).attr("itemId"), $(this).val());
  });

  Shopify.onCartUpdate = function (cart) {
    if (cart.items.length > 0) {
      cart.items.forEach((cartItem) => {
        const id = cartItem.id;
        const element = $(`tr[data-item-id="${id}"]`);
        updateItemPrice(cartItem, element);
      });
      updateCart(cart);
    } else {
      window.location.reload();
    }
  };
  
  function updateItemPrice(cartItem, element) {
    element.find(".subtotal").text(Shopify.formatMoney(cartItem.line_price));
    element.find(".cart-qty").val(cartItem.quantity);
  }
  
  function updateCart(cart) {
    const total_discount = Shopify.formatMoney(cart.total_discount);
    const discount_banner = $(".discount-banner-section");
    const discount_price = $(".total-discount-price");
    const cart_disprice = $(".cart-total-discount-price");

    if (cart.total_discount) {
      discount_banner.css("display", "block");
      discount_price.css("display", "block");
      if (discount_price.length) {
        cart_disprice.text(total_discount);
      } else {
        discount_price.append(`<th class="text-left">Discount</th><td class="text-right cart-total-discount-price">${total_discount}</td>`);
      }
      if (!discount_banner.length) {
        discount_price.append('<div class="discount-banner"><h4 class="discount-message">Discount Successfully Applied</h4></div>');
      }
    } else {
      discount_banner.css("display", "none");
      discount_price.css("display", "none");
    }
    $(".cart-subtotal").text(Shopify.formatMoney(cart.original_total_price));
    $(".cart-grandtotal").text(Shopify.formatMoney(cart.total_price));
  }

  const cart_dropdown = $(".drop-down");
  $(".remove_cart_product").click(function (e) {
    e.preventDefault();
    if ($(this).attr("itemId")) {
      $(this).parents("tr").fadeOut();
      Shopify.removeItem($(this).attr("itemId"));
    }
  });

  $(".cart-qty").click(function (e) {
    e.stopPropagation();
    cart_dropdown.hide();
    $(this).parent().find(".drop-down").show();
  });

  $("div.qty-dropdown .qty-value").click(function (e) {
    $(this).parents(".cart-row").find(".cart-qty").val($(this).text());
    const itemId = $(this).parents(".cart-row").find(".cart-qty").attr("itemId");
    $(this).parents(".cart-row").find(".cart-qty").trigger("change");
    cart_dropdown.hide();
    Shopify.changeItem(itemId, $(this).text());
  });

  $(document).click(function () {
    cart_dropdown.hide();
  });

  // product variant changes
  function initProductOptions() {
    $('body').on('change', '.productitem-option1-js ', function(e) {
      const $this = $(this);
      optionsHandlerOnChange(e, $this);
      const _parent = $this.closest('.product_inside_info');
      const val = _parent.optionsSetParams(this.selectedOptions[0].attributes['data-tag'].value, '.productitem-option2-js');
      _parent.optionsSetParams(val, '.productitem-option3-js');
    });

    $('body').on('click', '.productitem-option1-js a', function(e) {
      const $this = $(this)
      optionsHandler(e, $this);
      const _parent = $this.closest('.product_inside_info');
      const attr =  $this.parent().attr("data-tag");
      const val = _parent.optionsSetParams((`'${attr}-js'`), '.productitem-option2-js');
      _parent.optionsSetParams(val, '.productitem-option3-js');
    });

    $('body').on('click', '.productitem-option2-js a', function(e) {
      const $this = $(this)
      optionsHandler(e, $this);
      const val = `"${$this.parent().attr("data-tag")}-js"`;
      const _parent = $this.closest('.product_inside_info');
      _parent.optionsSetParams(val, '.productitem-option3-js');
    });

    $('body').on('click', '.productitem-option3-js a', function(e) {
      optionsHandler(e, $(this));
    });
  }

  function optionsHandler(e, $this) {
    e.preventDefault();
    setNewData($this);
  }

  function optionsHandlerOnChange(e, $this) {
    e.preventDefault();
    setNewDataOnchange($this);
  }

  $.fn.optionsSetParams = function(val, str) {
    const _opt = this.find(str);
    if(_opt.length == 0) return false;
    _opt.show().find('li').each(function() {
      $(this).hide().removeClass('active')
    });
    if(_opt.find(`[data-current-option="${val}"]`).length == 0) return false;
    _opt.find(`[data-current-option="${val}"]`).show().first().addClass('active');
    return `'${_opt.find('.active').find('a').parent().attr("data-tag")}-js'`;
  }

  function setNewDataOnchange($this) {
    const _parent = $this.parent();
    _parent.parent().find(".active").removeClass('active');
    _parent.addClass('active');
    const $pr_parent = $this.closest('.product');

    $pr_parent.find('input').val(_parent.attr('data-var_id'));
    const img_src = $this.children("option:selected")[0].attributes['data-img'].value;
    if(img_src !== '') $this.parent().parents('.product_inside').find('.image-box').children().find('img').first().attr('src', img_src);

    const mainprice = _parent.parents('.listing-product-content-wrap').find('.price span:first-child');
    const newprice = $this.children("option:selected")[0].attributes['data-price'].value;
    const oldprice = _parent.parent().find('.old-price');
    mainprice.html(Shopify.formatMoney(newprice));
    const compprice = String(_parent.attr('data-compprice'));
    oldprice.html(Shopify.formatMoney(compprice));

    if(!compprice) {
      !oldprice.hasClass('hide') && oldprice.addClass('hide');
      mainprice.hasClass('new-price') && mainprice.removeClass('new-price');
    } else {
      oldprice.hasClass('hide') && oldprice.removeClass('hide');
      !mainprice.hasClass('new-price') && mainprice.addClass('new-price');
    }
    $('body').trigger('refreshCurrency');
  }

  function setNewData($this) {
    const _parent = $this.parent();
    _parent.parent().find(".active").removeClass('active');
    _parent.addClass('active');
    const $pr_parent = $this.closest('.product');
    $pr_parent.find('input').val(_parent.attr('data-var_id'));
    const img_src = _parent.attr('data-img');
    if(img_src !== '') $pr_parent.find('img').first().attr('src', img_src);
    const mainprice = $pr_parent.find('.price span:first-child');
    const oldprice = $pr_parent.find('.old-price');
    mainprice.html(Shopify.formatMoney(_parent.attr('data-price')));
    const compprice = String(_parent.attr('data-compprice'));
    oldprice.html(Shopify.formatMoney(compprice));

    if(!compprice) {
      !oldprice.hasClass('hide') && oldprice.addClass('hide');
      mainprice.hasClass('new-price') && mainprice.removeClass('new-price');
    } else {
      oldprice.hasClass('hide') && oldprice.removeClass('hide');
      !mainprice.hasClass('new-price') && mainprice.addClass('new-price');
    }
    $('body').trigger('refreshCurrency');
  }
  initProductOptions();
});

// Money Js
var Shopify = Shopify || {};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.','');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) {
      return 0;
    }
	number = (number/100.0).toFixed(precision);
	const parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
